import useMobileHeroAmenityImage from '@/hooks/useMobileHeroAmenityImage'
import useMobileHeroCityImage from '@/hooks/useMobileHeroCityImage'
import { Image } from 'pcln-design-system'

export default function HeroMobile() {
  const mobileHeroCityImage = useMobileHeroCityImage()
  const mobileHeroAmenityImage = useMobileHeroAmenityImage()
  const mobileHeroImage = mobileHeroCityImage || mobileHeroAmenityImage

  return mobileHeroImage ? (
    <div className='m-4 max-h-[110px] overflow-hidden rounded-lg'>
      <Image
        src={mobileHeroImage.src}
        width='393px'
        height='131px'
        alt={`Picture of ${mobileHeroImage.altName}`}
        className='mobile-hero-image'
      />
    </div>
  ) : null
}
